import * as SettingsActionTypes from 'actiontypes/settings';
import SettingsService from 'services/SettingsService';

export const deactivateAccountRequested = () => ({
  type: SettingsActionTypes.DEACTIVATE_ACCOUNT_REQUESTED,
  isDeactivating: true,
});

export const deactivateAccountSuccess = response => ({
  type: SettingsActionTypes.DEACTIVATE_ACCOUNT_SUCCESS,
  isDeactivating: false,
  isSuccess: response.isSuccess,
  message: response.message,
});

export const deactivateAccountFailure = error => ({
  type: SettingsActionTypes.DEACTIVATE_ACCOUNT_FAILURE,
  isDeactivating: false,
  error: true,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
 * DEACTIVATE ACCOUNT
 -----------------------------------------------------------------------------*/
export default deactivateAccount(new SettingsService());

export function deactivateAccount(service) {
  return () => async (dispatch) => {
    dispatch(deactivateAccountRequested());

    // Uncomment to actually _do_ the thing
    try {
      const { data } = await service.deactivateAccount();
      dispatch(deactivateAccountSuccess(data));
      return data;
    } catch (error) {
      dispatch(deactivateAccountFailure(error));
      return error;
    }
  };
}